import { cn } from '@/shadcn-ui/utils';
import Spacer from './spacer';

export type BannerVariants =
  | 'default'
  /** Whit background with rounded tops  */
  | 'white-bg-rounded-top-border-radius'
  /** Black background with not extra spacing */
  | 'black-bg-bottom-border-no-spacer'
  /** Default styling with no spacing */
  | 'no-spacer'
  /** Blue banner with no spacer */
  | 'blue-bg-no-spacer'
  /** Gray background with no spacer */
  | 'gray-bg-no-spacer'
  /** Light gray background with no spacer */
  | 'light-gray-bg-no-spacer';

export type BannerProps = {
  variant?: BannerVariants;
  children: React.ReactNode;
  ref?: React.RefObject<HTMLDivElement | null>;
};

/**
 * Create banner intended for top of page
 * @param variant which styling do we apply? This is from a fixed list of options and has a default styling if no variant is specified
 */
export default function Banner({ variant = 'default', children, ref }: BannerProps) {
  return (
    <>
      <div
        className={cn({
          'bg-flexcar-neutral90':
            variant === 'default' || variant === 'light-gray-bg-no-spacer',
          'bg-flexcar-neutral5': variant === 'black-bg-bottom-border-no-spacer',
          'border-b border-solid border-white border-opacity-20':
            variant === 'black-bg-bottom-border-no-spacer',
          'bg-background': variant === 'white-bg-rounded-top-border-radius',
          'bg-flexcar-blue90': variant === 'blue-bg-no-spacer',
          'bg-flexcar-neutral80': variant === 'gray-bg-no-spacer',
        })}
        ref={ref}
      >
        <div
          className={cn('block w-full justify-center px-[24px] py-[8px] text-center', {
            'rounded-t-[16px]': variant === 'white-bg-rounded-top-border-radius',
            'p-[0]': variant === 'white-bg-rounded-top-border-radius',
          })}
        >
          {children}
        </div>
      </div>
      {(variant === 'default' || variant === 'white-bg-rounded-top-border-radius') && (
        <Spacer variant="height48" />
      )}
    </>
  );
}
